import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { UserPagedCollectionParams } from '../../../models/user-paged-collection-params';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { jobTraceIdResponseSchema } from '../schemas/job-trace-id-response.schema';

/**
 * Send an invite to filtered assets based on fleet info criteria.
 * @param params User Paged Collection Params
 * @param samsaraMessageEnabled A flag indicating if Samsara messaging is enabled via the feature flag
 * @returns The job trace ID
 */
export function postBulkAssetInvite(
  this: unknown,
  params: UserPagedCollectionParams,
  samsaraMessageEnabled: boolean,
  inviteLanguage: string,
  assetIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).bulkAssetInviteUrl()}?${params.urlParams}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify({
            samsaraMessageEnabled,
            inviteLanguage,
            assetIds: assetIds.length > 0 ? assetIds : undefined,
          }),
        }
      )
    )
  ).pipe(selectData(jobTraceIdResponseSchema));
}
